import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import {
  FaEnvelope,
  FaFlickr,
  FaGithub,
  FaLinkedin,
  FaMapMarker,
  FaPhoneAlt,
  FaTwitter,
} from "react-icons/fa";
import "./contact.scss";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_l8824ag', 'template_x1wvb5f', form.current, '2bbzGiJah99wQFATz')
      .then((result) => {
          // console.log(result.text);
      }, (error) => {
          // console.log(error.text);
      });
  };
  return (
    <div className="contact-section " id="contact">
      <div className="txt">
        <h1>Get in touch</h1>
        <p>
          Am just a call or an Email away from transforming that beautiful Idea
          into a profitable product.
        </p>
      </div>
      <div className="conta-section flex">
        <div className="contacts column">
          <div className="conts column">
            <div className="contact flex">
              <h1 className="icon flex">
                <FaPhoneAlt />
              </h1>
              <div className="text">
                <h2>Phone</h2>
                <h4>+256 755623472</h4>
              </div>
            </div>
            <div className="contact flex">
              <h1 className="icon flex">
                <FaEnvelope />
              </h1>
              <div className="text">
                <h2>Email</h2>
                <h4>ssekittoshafiq@gmail.com</h4>
              </div>
            </div>
            <div className="contact flex">
              <h1 className="icon flex">
                <FaMapMarker />
              </h1>
              <div className="text">
                <h2>Address</h2>
                <h4>Kampala,Uganda</h4>
              </div>
            </div>
          </div>
          <div className="social">
            <h1>follow me</h1>
            <ul className="social-icons flex">
              <li>
                <a href="https://www.linkedin.com/in/ssekitto-shafiq/">
                <FaLinkedin /></a>
              </li>
              <li>
                <a href="https://twitter.com/ssekittoshafiq">
                <FaTwitter /></a>
              </li>
              <li>
                <a href="https://github.com/shafiqlipse">
                <FaGithub /></a>
              </li>
              <li>
                <a href="https://www.flickr.com/photos/162743669@N03/">
                <FaFlickr /></a>
              </li>
            </ul>
          </div>
        </div>
        <form className="form-control column" ref={form} onSubmit={sendEmail}>
          <input type="text" placeholder="FullName"name="full_name"/>
          <input type="Email" placeholder="Your Email" required name="email"/>
          <select name="service" id="service">
            <option value="Dessired service">Dessired service</option>
            <option value="Web development">Web development</option>
            <option value="Web design (UI/UX)">Web design (UI/UX)</option>
            <option value="Graphics design">Graphics design</option>
            <option value="Database design(SQL)">Database design(SQL)</option>
            <option value="System Analysis & Design">System Analysis & Design</option>
          </select>
          <textarea
            name="message"
            id="msg"
            cols="30"
            rows="10"
            placeholder="Your Message"
          ></textarea>
          <button className="submit" type="submit" value="Send">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
